import { Observable, of } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { DefaultRouteParams, InjectableComponentOptions, LoginExtensionLink, MainMenuElement, ShareableEntity } from '@base/classes/BaseClasses';
import { BaseDataSourceAbstract } from '@base/datalayer/BaseDataSourceAbstract';
import { Routes } from '@angular/router';
import { EnumApplicationMode } from '@core/framework/sysenums.enum';
import { BaseInjectableComponent } from '@m4u-angular/base/component/BaseInjectableComponent';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';

//Injection token for application configuration
export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');

export class AppConfig {
    //Module name. Can be obtained from server WebApi project name without 'WebAPI' prefix
    ModuleName: string = '';
    //Project name that was set up in menahel4u.json. No need to override, it is set automatically
    ProjectName: string = '';
    //Application Mode
    Mode: EnumApplicationMode = EnumApplicationMode.Standard;
    //Turn on/off notifications
    IsAllowNotifications: boolean;
    //Turn on/off breadcrumb
    ShowBreadcrumb: () => boolean = () => false;

    //Array of components
    Components = [];
    //Array of entry components
    EntryComponents = [];
    //Array of endpoints
    Endpoints = [];
    //Array of services
    Services = [];
    //Array of routes
    RoutesProtected: Routes = [];
    RoutesAnonymous: Routes = [];
    //
    RoutesWithEmptyLayout: Routes = [];
    //
    SupportLegacyDisplaySizes: boolean = false;

    //Get menu function
    OnGetMenu = (userInfos?: { [moduleName: string]: any }): Observable<MainMenuElement[]> => of([]);
    //Get navbar items for mobile menu
    OnGetNavbarItems = (userInfos?: { [moduleName: string]: any }): Observable<MainMenuElement[]> => of([]);
    //Get default route path with params function
    OnGetDefaultRouteParams = (userInfo?: any): Observable<DefaultRouteParams> => of({} as DefaultRouteParams);
    //Get login page extension links function
    OnGetAppLoginExtensionLinks = (): Observable<LoginExtensionLink[]> => of([]);
    //Get global datasources function
    OnGetGlobalDataSources = (): Observable<{ [id: string]: BaseDataSourceAbstract }> => of({});
    //Get home page instead of system/login
    OnGetHomePagePath = () => '';

    //Application lifecycle functions
    //On init application function
    OnInitApplicationAsync = (userInfo?: any): Observable<boolean> => of(true);
    //On logout application function
    OnLogoutApplicationAsync = (): Observable<boolean> => of(true);
    //On login page. Provides posibility to config/exec an additional functionality
    OnLoginPage = () => of(true);

    //Get injectable components options
    GetInjectableComponentOptions = (): Observable<InjectableComponentOptions<BaseInjectableComponent<BaseEntity, BaseState>>[]> => of([]);

    //Get lists
    GetLists = (): any[] => [];

    //Module enums object
    Enums: any = {};

    // List of entities which can have default share button
    ShareableEntities: ShareableEntity[] = [];
}